// extracted by mini-css-extract-plugin
export var tosLink = "_7f-0";